// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"390374e2","453":"01f2b44f","796":"761905f3"}[chunkId] + ".chunk.js";
};